// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DepartmentsModal_container__wXBb4 {
  min-width: 600px;
  background-color: white;
  padding: 32px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-height: 600px;
  z-index: 10;
}

.DepartmentsModal_header__7FEov {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.DepartmentsModal_header__7FEov h4 {
  margin: 0;
  display: flex;
  gap: 6px;
}

.DepartmentsModal_header__7FEov p {
  margin: 0;
  color: blue;
}

.DepartmentsModal_header__7FEov span {
  cursor: pointer;
}

.DepartmentsModal_table__cNiLc {
  display: flex;
  flex-direction: column;
  height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
}

.DepartmentsModal_tableContent__iG-S7 {
  display: flex;
  padding: 12px 20px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  justify-content: space-between;
  color: #676c7e;
  line-height: 24px;
  &:hover {
    box-shadow: 0px 2px 4px 0px #00000014;
    box-shadow: 0px 6px 20px 0px #00000014;
    background-color: #f6f6f6;
  }
}

.DepartmentsModal_tableHeader__tFaNW {
  padding: 12px 20px;
  height: 20px;
  background-color: #3082f6;
  border-radius: 0 0 8px 8px;
  display: flex;
  justify-content: space-between;
  color: white;
}

.DepartmentsModal_tableHeader__tFaNW > div,
.DepartmentsModal_tableContent__iG-S7 > div {
  width: 100px;
  display: inline-block;
  white-space: normal;
  word-wrap: break-word;
}

.DepartmentsModal_notificationDiv__S3VXi,
.DepartmentsModal_error__EkmAy {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

.DepartmentsModal_error__EkmAy {
  background-color: red;
  border-radius: 8px;
  padding: 10px;
  font-weight: 500;
  margin-top: 1rem;
}
.DepartmentsModal_modalOverlay__feauL {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9; /* To ensure the modal is on top of the overlay */
}
.DepartmentsModal_orgBtn__ulMrU,
.DepartmentsModal_companyBtn__Ls563 {
  background-color: #3082f6;
  border: none;
  padding: 0 16px;
  border-radius: 12px;
  height: 44px;
  color: white;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/departmentsModal/DepartmentsModal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB;IACE,qCAAqC;IACrC,sCAAsC;IACtC,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU,EAAE,iDAAiD;AAC/D;AACA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB","sourcesContent":[".container {\r\n  min-width: 600px;\r\n  background-color: white;\r\n  padding: 32px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 32px;\r\n  max-height: 600px;\r\n  z-index: 10;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.header h4 {\r\n  margin: 0;\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n.header p {\r\n  margin: 0;\r\n  color: blue;\r\n}\r\n\r\n.header span {\r\n  cursor: pointer;\r\n}\r\n\r\n.table {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 350px;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.tableContent {\r\n  display: flex;\r\n  padding: 12px 20px;\r\n  border: 1px solid #f0f0f0;\r\n  border-radius: 8px;\r\n  justify-content: space-between;\r\n  color: #676c7e;\r\n  line-height: 24px;\r\n  &:hover {\r\n    box-shadow: 0px 2px 4px 0px #00000014;\r\n    box-shadow: 0px 6px 20px 0px #00000014;\r\n    background-color: #f6f6f6;\r\n  }\r\n}\r\n\r\n.tableHeader {\r\n  padding: 12px 20px;\r\n  height: 20px;\r\n  background-color: #3082f6;\r\n  border-radius: 0 0 8px 8px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  color: white;\r\n}\r\n\r\n.tableHeader > div,\r\n.tableContent > div {\r\n  width: 100px;\r\n  display: inline-block;\r\n  white-space: normal;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.notificationDiv,\r\n.error {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.error {\r\n  background-color: red;\r\n  border-radius: 8px;\r\n  padding: 10px;\r\n  font-weight: 500;\r\n  margin-top: 1rem;\r\n}\r\n.modalOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 9; /* To ensure the modal is on top of the overlay */\r\n}\r\n.orgBtn,\r\n.companyBtn {\r\n  background-color: #3082f6;\r\n  border: none;\r\n  padding: 0 16px;\r\n  border-radius: 12px;\r\n  height: 44px;\r\n  color: white;\r\n  font-size: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DepartmentsModal_container__wXBb4`,
	"header": `DepartmentsModal_header__7FEov`,
	"table": `DepartmentsModal_table__cNiLc`,
	"tableContent": `DepartmentsModal_tableContent__iG-S7`,
	"tableHeader": `DepartmentsModal_tableHeader__tFaNW`,
	"notificationDiv": `DepartmentsModal_notificationDiv__S3VXi`,
	"error": `DepartmentsModal_error__EkmAy`,
	"modalOverlay": `DepartmentsModal_modalOverlay__feauL`,
	"orgBtn": `DepartmentsModal_orgBtn__ulMrU`,
	"companyBtn": `DepartmentsModal_companyBtn__Ls563`
};
export default ___CSS_LOADER_EXPORT___;
